/**
 * يحدّد ما إذا كان آمناً تسجيل push subscription في هذا السياق.
 * نمنع Preview / Iframe / hosts غير الإنتاج لئلا نلوث الـ SW أثناء التطوير.
 */
export function isPushAllowedContext(): boolean {
  if (typeof window === "undefined") return false;

  // داخل iframe (معاينة Lovable مثلاً) → ممنوع
  try {
    if (window.self !== window.top) return false;
  } catch {
    return false;
  }

  const host = window.location.hostname;
  if (
    host.includes("id-preview--") ||
    host.includes("lovableproject.com") ||
    host.includes("lovable.app")
  ) {
    // lovable.app = الإنتاج المنشور لـLecmo؛ مسموح
    // إلّا أنّ id-preview وlovableproject هي iframes
    if (host.includes("id-preview--") || host.includes("lovableproject.com")) return false;
  }

  // المتصفّح يدعم Push؟
  if (!("serviceWorker" in navigator)) return false;
  if (!("PushManager" in window)) return false;
  if (!("Notification" in window)) return false;

  return true;
}

/**
 * iOS Safari يدعم Web Push فقط بعد «إضافة للشاشة الرئيسيّة».
 * نعرض تلميحاً لطيفاً للمستخدم بدل فشل صامت.
 */
export function isIosNeedsInstall(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isIos = /iPad|iPhone|iPod/.test(ua);
  if (!isIos) return false;
  // في وضع PWA المثبّت، display-mode = standalone
  const standalone =
    (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    // @ts-expect-error iOS-specific
    window.navigator.standalone === true;
  return !standalone;
}
